// The reason we are suppressing it is the app colors are failing
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum colors {
  white = '#ffffff',
  black = '#000000',
  // Primary
  primaryMain = '#306FB7',
  primaryDark = '#1C2255',
  primaryLight = '#72C8F1',
  // Secondary
  secondaryMain = '#333333',
  // Info
  infoMain = '#0288D1',
  infoDark = '#01579B',
  infoLight = '#03A9F4',
  infoLight4p = '#0288D10A',
  infoLight50p = '#0288D180',
  // Success
  successMain = '#2E7D32',
  successDark = '#1B5E20',
  successLight = '#4CAF50',
  // Error
  errorMain = '#D32F2F',
  errorDark = '#C62828',
  errorLight = '#EF5350',
  // Warning
  warningMain = '#ED6C02',
  warningDark = '#E65100',
  warningLight = '#FF9800',

  // Web App Specific Colours
  linkBackgroundHover = '#EFEFEF',
  greyText = '#333333',
  backgroundGrey = '#F2F1F1',
  linkColor = '#1659B6',
  tabsColorUnderline = '#D0D0D0',
  tabsColor = '#707070',
  tabsColorSelected = '#555555',
  tabsColorHover = '#333333',
  errorBackground = '#F5DCE1',
  headerAppBarBorder = '#F2F1F1',
  footerBackground = '#212121',

  romanSlate20 = '#E7E8EA',
  romanSlate40 = '#CFD2D5',

  accentColor = '#CE3AA8',
  accentColorDark = '#7B1FA2',
  accentColor4p = '#CE3AA80A',
}
